import { FuseNavigationModelInterface } from '../core/components/navigation/navigation.model';

export class EmptyNavigationModel implements FuseNavigationModelInterface {
    public model: any[];

    constructor() {
        this.model = [
            {            
            },
        ];
    }
}




// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/navigation/emptyNavigation.model.ts